module.exports = __webpack_public_path__ + "static/media/blue_copy.ad31af45.svg";